import React, { useState } from 'react';
import { FaQuestionCircle, FaTimes } from 'react-icons/fa';

const HelpTooltip = ({ content, title }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="relative inline-block">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="ml-2 text-gray-400 hover:text-purple-600 transition-colors"
        aria-label="Help"
      >
        <FaQuestionCircle className="text-sm" />
      </button>
      {isOpen && (
        <>
          <div
            className="fixed inset-0 z-40"
            onClick={() => setIsOpen(false)}
          />
          <div className="absolute left-0 top-6 w-64 bg-white border border-gray-200 rounded-lg shadow-xl p-4 z-50">
            <div className="flex justify-between items-start mb-2">
              {title && <h4 className="font-semibold text-gray-800 text-sm">{title}</h4>}
              <button
                onClick={() => setIsOpen(false)}
                className="text-gray-400 hover:text-gray-600"
                aria-label="Close"
              >
                <FaTimes className="text-xs" />
              </button>
            </div>
            <p className="text-sm text-gray-600">{content}</p>
          </div>
        </>
      )}
    </div>
  );
};

export default HelpTooltip;



